import { render, staticRenderFns } from "./ziyuan138.vue?vue&type=template&id=a127d702&"
import script from "./ziyuan138.vue?vue&type=script&lang=js&"
export * from "./ziyuan138.vue?vue&type=script&lang=js&"
import style0 from "./ziyuan138.vue?vue&type=style&index=0&id=a127d702&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports